export default "__VITE_ASSET__fce78adf__"